module.exports = function() {
  return new Worker("/" + "download.worker.ddead9a5786d3ffa9bf9.js");
};